// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__YiBMd","list":"Navbar_list__31Uc8","stuck":"Navbar_stuck__21aFq","brand":"Navbar_brand__2xOjK"};